module.exports = __webpack_public_path__ + "static/media/procreate.22376835.jpg";